export default __webpack_public_path__ + "static/shivekkhurana-e4de13aa3e033c446f9850c90d73ad34.jpg";